import {EPaymentType, EResellerIds, useGetTenantDataQuery, useReseller} from 'src/containers/User';

const DISABLED_COUNTRY_CODES = [
  'AZ',
  'AZE',
  'AM',
  'ARM',
  'BY',
  'BLR',
  'KZ',
  'KAZ',
  'KG',
  'KGZ',
  'MD',
  'MDA',
  'TJ',
  'TJK',
  'UZ',
  'UZB',
  'TM',
  'TKM',
  'GE',
  'GEO',
];

const useInvoiceEnabled = () => {
  const isMFM = useReseller(EResellerIds.MFM_ID);

  const {data: tenant} = useGetTenantDataQuery();

  if (isMFM && tenant?.selfRegistered) {
    return false;
  }

  if (isMFM && tenant?.paymentType === EPaymentType.PREPAYMENT && tenant?.country) {
    return !DISABLED_COUNTRY_CODES.includes(tenant.country);
  }

  return true;
};

export {useInvoiceEnabled};
